module.exports = __webpack_public_path__ + "static/img/LaurenWood.0c52ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LaurenWood.jpg
// module id = mzTi
// module chunks = 0